/**
 * 忽略函数执行的返回值
 */
export function voidify(fn) {
  return function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    fn.apply(void 0, args);
  };
}